
namespace Matrix {

    const defaultTextFormat = "{{$id}} - {{$name}}";
    const defaultSelectionFormat = '<span title="{{$id}} - {{$name}}"><b>{{$id}}</b> - <span style="white-space: nowrap;">{{$name}}</span></span>';
    const defaultResultFormat = '<div class="row" title="{{$id}} - {{$name}}"><div class="col-4" style="overflow:hidden;"><b>{{$id}}</b></div><div class="col-8"><span style="white-space: nowrap;">{{$name}}</span></div></div>';

    @Serenity.Decorators.registerEditor("Matrix.FormatLookupEditor")
    export class FormatLookupEditorBase<TOptions extends FormatLookupEditorOptions, TItem>
        extends Serenity.LookupEditorBase<TOptions, TItem> {

        constructor(input: JQuery, opt: TOptions) {
            super(input, opt);
        }

        private format(item: TItem, fmt: string, encode: boolean): string {
            if (!fmt) {
                var result = item[this.lookup.textField];
                if (encode)
                    return Q.htmlEncode(result);

                return result;
            }

            item = $.extend({}, item, {
                $id: item[this.lookup.idField],
                $name: item[this.lookup.textField]
            });

            return Q.microFormat(fmt, item, {
                htmlEncode: encode
            });
        }

        public getItemText(item: TItem, lookup: Q.Lookup<TItem>) {
            return this.format(item, this.options.textFormat || defaultTextFormat, false);
        }

        public getSelect2Options() {
            var opt = super.getSelect2Options();

            opt.formatResult = (item: Serenity.Select2Item) => {
                if (!item.source) {
                    return Q.htmlEncode(item.text);
                }
                return this.format(item.source, this.options.resultFormat || defaultResultFormat, true);
            };

            opt.formatSelection = (item: Serenity.Select2Item) => {
                if (!item)
                    return null;

                if (!item.source) {
                    return Q.htmlEncode(item.text);
                }

                return this.format(item.source, this.options.selectionFormat || defaultSelectionFormat, true);
            };

            opt.dropdownCssClass = "big-dropdown";
            //opt.dropdownAutoWidth = true;
            return opt;
        }

        protected filterItems(items: TItem[]): TItem[] {
            var val = this.get_filterValue();
            if (val == null || val === '') {
                return items;
            }

            var key = val.toString();
            var parts = key.split(',').map(x => Q.trimToNull(x)).filter(x => x != null);
            var fld = this.get_filterField();
            return items.filter(function (x) {
                var itemKey = Q.coalesce(x[fld], Serenity.ReflectionUtils.getPropertyValue(x, fld));
                if (itemKey == null)
                    return false;
                itemKey = itemKey.toString();
                return itemKey === key || (parts.length > 1 && Q.any(parts, x => x === itemKey));
            });
        }

        protected getFilterCriteria() {
            var filterField = this.get_filterField();
            var filterValue = this.get_filterValue();
            if (Q.isEmptyOrNull(filterField) ||
                filterValue == null || filterValue === '')
                return null;

            var crit = [[filterField], '=', filterValue];

            var parts = filterValue.toString().split(',').map(x => Q.trimToNull(x)).filter(x => x != null);
            if (parts.length > 0)
                crit = Serenity.Criteria.or(crit, [[filterField], 'in', [parts]]);

            return crit;
        }
    }

    export interface FormatLookupEditorOptions extends Serenity.LookupEditorOptions {
        resultFormat?: string;
        selectionFormat?: string;
        textFormat?: string;
    }

    @Serenity.Decorators.registerEditor("Matrix.FormatLookupEditor")
    export class FormatLookupEditor extends FormatLookupEditorBase<FormatLookupEditorOptions, any> {

        constructor(input: JQuery, opt: FormatLookupEditorOptions) {
            super(input, opt);
        }
    }

    export class FormatLookupPickerBase<TOptions extends FormatLookupEditorOptions, TItem>
        extends FormatLookupEditorBase<TOptions, TItem> {

        constructor(element: JQuery, opt: TOptions) {
            super(element, $.extend(opt, { delimited: true }));

            $('<a class="inplace-button inplace-edit"><b><i class="mdi mdi-shape-square-plus"></i></b></a>')
                .attr("title", "Select")
                .insertAfter(this.element)
                .click(e => {
                    this.handleEditClick();
                });

            $(window).on('resize.' + this.uniqueName, e => {
                this.element.prevAll('.select2-container').find('.multiple-selected').css('max-width', (this.element.prevAll('.select2-container').width() - 65) + 'px');
            });
                
            this.change(e => this.updateMultipleSelect());
        }


        protected displayName() {
            return "items";
        }

        handleEditClick() {
            Q.notifyError("Please override handleEditClick!");
        }

        destroy() {
            $(window).off('resize.' + this.uniqueName);
            super.destroy();
        }

        protected updateMultipleSelect() {
            if (!this.isMultiple())
                return;

            var choicesDiv = this.element.prevAll('.select2-container').children('.select2-choices');
            var choices = choicesDiv.children('.select2-search-choice').not('.multiple-selected');
            if (choices.show().length < 2 ||
                choices.first().position().top > choicesDiv.children('.select2-search-field').position().top - 2) {
                choicesDiv.children('.multiple-selected').hide();
                return;
            }

            if (!choicesDiv.children('.multiple-selected').length) {
                $('<li class="select2-search-choice multiple-selected" style="white-space: nowrap; overflow: hidden"><a href="#" class="select2-search-choice-close" tabindex="-1"></a><span></span></li>')
                    .insertAfter(choices.last())
                    .children('a').click(e => this.values = []);
            }
            
            choices.hide();
            choicesDiv.children('.multiple-selected')
                .children('span').text(choices.length + " " + this.displayName() + " selected")
                .end().css('max-width', (this.element.prevAll('.select2-container').width() - 65) + 'px');
                
        }
    }

}